import React = require('react');
import { Query } from 'react-apollo';
import { VirtualConnectionCustomSqlQuery, VirtualConnectionCustomSqlQueryVariables } from '../../../gen-src/queries/VirtualConnectionCustomSqlQuery';
import { VirtualConnectionCustomSqlQueryGql } from '../../queries/VirtualConnectionCustomSqlQueryGql';
import { renderQueryResult } from '../renderQueryResult';
import { CustomSQLTable, CustomSqlTextLink } from './CustomSqlDialog';

export type VirtualConnectionCustomSqlQueryWrapperProps = {
  readonly virtualConnectionId: string;
};

export function VirtualConnectionCustomSqlQueryWrapper(props: VirtualConnectionCustomSqlQueryWrapperProps): JSX.Element {

  return (
    <Query<VirtualConnectionCustomSqlQuery, VirtualConnectionCustomSqlQueryVariables>
      query={VirtualConnectionCustomSqlQueryGql}
      variables={{ vizportalUrlId: props.virtualConnectionId }}
    >
      {result => renderQueryResult(result, {
        renderData: renderCustomSqlQueries
      })}
    </Query>
  )
}

function renderCustomSqlQueries(data: VirtualConnectionCustomSqlQuery): JSX.Element | null {
  const connection = data && data.virtualConnections ? data.virtualConnections[0] : null;
  if (!connection) {
    return null;
  }

  const customSqlMap = new Map();
  connection.tables.forEach((table) => {
    table.columns.forEach((column) => {
      if (column.remoteColumn?.table?.__typename === 'CustomSQLTable') {
        customSqlMap.set( column.remoteColumn.table.id, column.remoteColumn.table);
      }
    });
  });

  if (customSqlMap.size === 0) {
    return null;
  }

  const customSqlTables: Array<CustomSQLTable> = Array.from(customSqlMap.values());
  return (
    <CustomSqlTextLink
      containsUnsupportedCustomSql={customSqlTables.some(table => table.isUnsupportedCustomSql ?? false)}
      customSQLTables={customSqlTables}
      contentType={connection.__typename}
    />
  );
}

